import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Video, FileEdit, LogOut, ExternalLink } from "lucide-react";
import { useAdmin } from "../contexts/AdminContext";
import VideosTab from "./admin/VideosTab";
import EditPageTab from "./admin/EditPageTab";

const TABS = [
  { id: "videos", label: "Videos", icon: Video },
  { id: "edit", label: "Editar página", icon: FileEdit },
];

const AdminDashboard = () => {
  const { logout } = useAdmin();
  const navigate = useNavigate();
  const [tab, setTab] = useState("videos");

  const handleLogout = () => {
    logout();
    navigate("/admin/login");
  };

  return (
    <div style={{ minHeight: "100vh", background: "#F4F1EA" }}>
      <header
        style={{
          background: "#fff",
          borderBottom: "1px solid rgba(26,19,82,0.08)",
          position: "sticky",
          top: 0,
          zIndex: 30,
        }}
      >
        <div
          style={{
            maxWidth: 1240,
            margin: "0 auto",
            padding: "14px 24px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 16,
            flexWrap: "wrap",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
            <span
              style={{
                width: 34,
                height: 34,
                borderRadius: 10,
                background: "linear-gradient(135deg,#5446EA,#C04ABF)",
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                color: "#fff",
                fontWeight: 800,
              }}
            >
              AE
            </span>
            <div style={{ lineHeight: 1.15 }}>
              <div style={{ fontWeight: 800, color: "#1A1352" }}>ActiveEnglish</div>
              <div style={{ fontSize: 12, color: "#5F5A72" }}>Panel de Administración</div>
            </div>
          </div>

          <nav style={{ display: "flex", gap: 6, alignItems: "center" }}>
            {TABS.map((t) => {
              const Icon = t.icon;
              const active = tab === t.id;
              return (
                <button
                  key={t.id}
                  onClick={() => setTab(t.id)}
                  style={{
                    background: active ? "#1A1352" : "transparent",
                    color: active ? "#fff" : "#1A1352",
                    border: "none",
                    padding: "10px 18px",
                    borderRadius: 999,
                    fontSize: 14,
                    fontWeight: 600,
                    cursor: "pointer",
                    display: "inline-flex",
                    alignItems: "center",
                    gap: 8,
                    boxShadow: active
                      ? "0 5px 0 0 #0B0830, 0 8px 16px -4px rgba(11,8,48,0.4)"
                      : "none",
                    transition: "all 180ms ease",
                  }}
                >
                  <Icon size={15} />
                  {t.label}
                </button>
              );
            })}
          </nav>

          <div style={{ display: "flex", gap: 8 }}>
            <a
              href="/"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-ghost"
              style={{ fontSize: 13 }}
            >
              <ExternalLink size={14} /> Ver sitio
            </a>
            <button onClick={handleLogout} className="btn-ghost" style={{ fontSize: 13 }}>
              <LogOut size={14} /> Salir
            </button>
          </div>
        </div>
      </header>

      <main style={{ maxWidth: 1240, margin: "0 auto", padding: "32px 24px 80px" }}>
        {tab === "videos" && <VideosTab />}
        {tab === "edit" && <EditPageTab />}
      </main>
    </div>
  );
};

export default AdminDashboard;
